<div class="app-frame">
  <mat-toolbar color="primary" class="topbar">
    <span class="brand">
      <mat-icon aria-hidden="true">favorite</mat-icon>
      <span>GagePeopleMeet</span>
    </span>
    <span class="spacer"></span>
  </mat-toolbar>

  <div class="shell">
    <main class="container content">
      <router-outlet />
    </main>
  </div>

  <nav class="bottom-nav" aria-label="Primary">
    <a class="nav-item" routerLink="/swipe" routerLinkActive="active">
      <mat-icon aria-hidden="true">swipe</mat-icon>
      <span>Swipe</span>
    </a>
    <a class="nav-item" routerLink="/chat" routerLinkActive="active">
      <mat-icon aria-hidden="true" [matBadge]="matches.matches().length" [matBadgeHidden]="matches.matches().length === 0" matBadgeColor="warn">chat</mat-icon>
      <span>Chat</span>
    </a>
    <a class="nav-item nav-item--quiz" routerLink="/quiz" routerLinkActive="active">
      <mat-icon aria-hidden="true">psychology</mat-icon>
      <span class="nav-item__long">Compatability Quiz</span>
    </a>
    <a class="nav-item" routerLink="/about" routerLinkActive="active">
      <mat-icon aria-hidden="true">info</mat-icon>
      <span>About</span>
    </a>

  </nav>
</div>

